import { render, staticRenderFns } from "./custom-company-exhibition.vue?vue&type=template&id=5c5272bc&scoped=true&"
import script from "./custom-company-exhibition.vue?vue&type=script&lang=js&"
export * from "./custom-company-exhibition.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-exhibition.vue?vue&type=style&index=0&id=5c5272bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5272bc",
  null
  
)

export default component.exports